import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuthStore } from '../store/authStore';
import { useVacancyStore } from '../store/vacancyStore';
import { VacanciesPageUnified } from '../components/VacanciesPage';

const VacancyList: React.FC = () => {
  // ОТКЛЮЧЕНИЕ ЛОГИНА: Убираем проверки авторизации
  const { isLoading } = useAuthStore();
  const navigate = useNavigate();
  const { selectedVacancyId } = useVacancyStore();

  // Автоматический редирект на страницу вакансии, если она выбрана
  useEffect(() => {
    if (selectedVacancyId) {
      navigate(`/recruiter/vacancy/${selectedVacancyId}`, { replace: true });
    }
  }, [selectedVacancyId, navigate]);

  if (isLoading) {
    return <div className="flex items-center justify-center min-h-96 text-gray-500">Загрузка...</div>;
  }

  // Оригинальная проверка isAuth закомментирована
  // if (!isAuth) {
  //   return null;
  // }

  return (
    <div className="flex items-center justify-center min-h-screen bg-[#f5f6f1]">
      <div className="text-center ai-fade-in">
        <div className="text-2xl font-semibold text-[#0a0d14] mb-4">
          Выберите вакансию или создайте новую
        </div>
        <div className="text-sm text-[#868c98]">
          Используйте меню слева для выбора вакансии
        </div>
      </div>
    </div>
  );

  // Временно закомментировано
  // return (
  //   <VacanciesPageUnified
  //     activeTab="vacancies"
  //     onTabChange={(id: string) => {
  //       if (id === 'relevanter') navigate('/recruiter/relevanter');
  //       if (id === 'vacancies') navigate('/recruiter/vacancies');
  //       if (id === 'statistics') navigate('/recruiter/reports');
  //       if (id === 'team') navigate('/recruiter/team');
  //     }}
  //     onEditVacancy={(vacancyId: number) => {
  //       // Обрабатываем редактирование в текущей странице
  //       console.log('🔍 onEditVacancy: редактируем вакансию', vacancyId);
  //       // Здесь можно добавить логику для показа формы редактирования
  //     }}
  //     onUserProfileClick={() => navigate('/recruiter/control?tab=personal')}
  //     onCreateInterview={(positionId: number) => {
  //       // Не перенаправляем на отдельную страницу, а используем встроенную форму
  //       console.log('🔍 onCreateInterview: используем встроенную форму для positionId:', positionId);
  //     }}
  //     onCandidateClick={(candidateId: string) => navigate(`/recruiter/candidates/${candidateId}`)}
  //   />
  // );
};

export default VacancyList; 
